import * as React from 'react';

const SvgComponent = _props => {
  const {'aria-label': ariaLabel, role, alt, ...rest} = _props;
  const props = {
    ...rest,
    ...(ariaLabel || alt
      ? {
          role: role || 'img',
          'aria-label': ariaLabel,
          alt
        }
      : {
          'aria-hidden': 'true'
        })
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 22" {...props}>
      <path
        d="M17.4.3c-2.1 0-4.1 1.1-5.3 2.8C10.9 1.4 8.9.3 6.8.3 3 .3 0 3.3 0 7c0 7.3 10.8 14.2 11.3 14.5.2.1.5.2.7.2s.5-.1.7-.2C13.1 21.2 24 14.3 24 7c0-3.7-3-6.7-6.6-6.7z"
        fill="#fff"
      />
    </svg>
  );
};

export default SvgComponent;
